import React from 'react';
import DrivingExemptionPage from './DrivingExemptionPage';
import FormContents from './FormContents';
import { gnhDrivingExemptionFormOnBehalf } from "./DrivingExemptionPageSelector";
import { ExemptionFormTypeEnum } from '../../../shared/enums/exemption-form-type-enum';

const GnhOnBehalfForm = () => {

    return (
        <DrivingExemptionPage selectedPage={gnhDrivingExemptionFormOnBehalf}>
            <FormContents onBehalf={true} formType={ExemptionFormTypeEnum.GNH}></FormContents>
        </DrivingExemptionPage>
    );
}

export default GnhOnBehalfForm;
